// ============================================================================
// Revised Romanization of Korean readings (spec §14.2). Portable core, no deps.
// Syllable-level mapping (initial + medial + final) — accurate for isolated
// readings and single Sino-Korean syllables (the eum), which is what the study
// UI romanizes. It does not apply cross-syllable assimilation, so stored word
// romanizations (from seed/Unihan) are preferred for multi-syllable words.
// ============================================================================

const S_BASE = 0xac00;
const N_JUNG = 21;
const N_JONG = 28;

// Revised Romanization tables, indexed to match the Unicode jamo order.
const CHO = ['g','kk','n','d','tt','r','m','b','pp','s','ss','','j','jj','ch','k','t','p','h'];
const JUNG = ['a','ae','ya','yae','eo','e','yeo','ye','o','wa','wae','oe','yo','u','wo','we','wi','yu','eu','ui','i'];
// Final (batchim) romanization: representative sound per jongseong.
const JONG = ['','k','k','k','n','n','n','t','l','k','m','p','l','l','l','l','m','p','p','t','t','ng','t','t','k','t','p','t'];

/** Romanize a single Hangul syllable code, or return the original char. */
function romanizeSyllable(code) {
  if (code < S_BASE || code > 0xd7a3) return String.fromCharCode(code);
  const s = code - S_BASE;
  const cho = Math.floor(s / (N_JUNG * N_JONG));
  const jung = Math.floor((s % (N_JUNG * N_JONG)) / N_JONG);
  const jong = s % N_JONG;
  return CHO[cho] + JUNG[jung] + JONG[jong];
}

/**
 * Romanize a Hangul string (per-syllable). Non-Hangul characters pass through.
 * @param {string} text
 * @returns {string}
 */
export function romanize(text) {
  if (!text) return '';
  let out = '';
  for (const ch of text) out += romanizeSyllable(ch.codePointAt(0));
  return out;
}
